import { render } from "./GuiideTransitionShallow.vue?vue&type=template&id=e4cd0416&scoped=true&ts=true"
import script from "./GuiideTransitionShallow.vue?vue&type=script&lang=ts"
export * from "./GuiideTransitionShallow.vue?vue&type=script&lang=ts"

import "./GuiideTransitionShallow.vue?vue&type=style&index=0&id=e4cd0416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cd0416"]])

export default __exports__